import { Provider } from "@angular/core";

import { QUERY_RESOLVER } from "@main/reporting.v3/core/query-hub/constants/query-hub.constants";

import { DashboardQueryResolverService } from "../services/dashboard-query-resolver.service";

export const dashboardQueryResolverProvider: Provider = {
    useExisting: DashboardQueryResolverService,
    provide: QUERY_RESOLVER,
}